import { RestoreRowActionOptions } from 'components/CIMSTable/CIMSTableContext/types/actions/row'
import { CASType } from '../../../../CASTypesContext/types'
import { Permission } from '@cims-online/shared'
import { useCASTypesContext } from '../../../../CASTypesContext'
import { DefaultMutationHookOptions } from 'utils/defaults'
import { useRestoreCasTypeMutation } from 'schema'
import { simpleRestoreNotification } from 'hooks/notificationHandler'

export function useRestore(): RestoreRowActionOptions<CASType> {
  const { refetch } = useCASTypesContext()
  const [restore] = useRestoreCasTypeMutation({
    ...DefaultMutationHookOptions,
    onCompleted: ({
      restoreCASType: {
        type: { name },
      },
    }) => simpleRestoreNotification(name),
  })
  return {
    permission: Permission.RemoveRestoreCASType,
    metadata: ({ deleted, deletedDate, deletedUser }) => ({
      removed: deleted,
      removedBy: deletedUser,
      removedDate: deletedDate,
    }),
    default: 'active',
    onRestore: async ({ id }) => {
      await restore({ variables: { id } })
      refetch()
    },
  }
}
